import {
  VisitNoteSummaryDTO,
} from 'dtos';
import {
  SaltType,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/VisitNoteSalt/SaltMenu';

const saltContentAvailabilityByType:
  Record<SaltType, (visitNote: VisitNoteSummaryDTO) => boolean> = {
    master: (visitNote) => visitNote.hasVisitNoteContent!,
    subjective: (visitNote) => visitNote.hasSubjective!,
    objective: (visitNote) => visitNote.hasObjective!,
    plan: (visitNote) => visitNote.hasPlan!,
    radiology: (visitNote) => visitNote.hasRadiology!,
    assessmentCodes: (visitNote) => visitNote.hasAssessmentCodes!,
    additionalAssessment: (visitNote) => visitNote.hasAdditionalAssessment!,
    billingCodes: (visitNote) => visitNote.hasBillingCodes!,
    customServiceCodes: (visitNote) => visitNote.hasCustomCodes!,
    unknown: () => true,
  };

const saltMenuItemDisabledTooltip: Record<SaltType, string> = {
  master: 'Visit note is empty',
  subjective: 'Subjective section is empty for this visit note',
  objective: 'Objective section is empty for this visit note',
  plan: 'Plan section is empty for this visit note',
  radiology: 'Radiology section is empty for this visit note',
  assessmentCodes: 'No assessment codes available for this visit note',
  additionalAssessment: 'Assessment section is empty for this visit note',
  billingCodes: 'No billing codes available for this visit note',
  customServiceCodes: 'No custom service codes available for this visit note',
  unknown: '',
};

const saltButtonDisabledTooltip: Record<SaltType, string> = {
  master: 'No content found in any prior visit note',
  subjective: 'No prior subjective notes available',
  objective: 'No prior objective notes available',
  plan: 'No prior plan notes available',
  radiology: 'No prior radiology information available',
  assessmentCodes: 'No prior assessment codes available',
  additionalAssessment: 'No prior assessment information available',
  billingCodes: 'No prior billing codes available',
  customServiceCodes: 'No prior custom service codes available',
  unknown: '',
};

export const isSaltContentAvailable = (
  visitNote: VisitNoteSummaryDTO,
  saltType: SaltType,
): boolean => saltContentAvailabilityByType[saltType]?.(visitNote) ?? true;

export const getsSaltMenuItemDisabledTooltip = (saltType: SaltType): string =>
  saltMenuItemDisabledTooltip[saltType] ?? '';

export const getsSaltButtonDisabledTooltip = (saltType: SaltType): string =>
  saltButtonDisabledTooltip[saltType] ?? '';
